<template>
  <v-dialog v-model="dialog" persistent max-width="680" :fullscreen="$store.getters.mobile" scrollable content-class="mesas-modal">
    <ValidationObserver v-slot="{ invalid }" ref="form">
      <v-card :key="key" class="mesas">
        <div class="mesas__encabezado">
          <v-icon color="white" class="mr-2">mdi-table-furniture</v-icon>
          <span class="mesas__titulo">{{ $t("tables") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="$emit('close')" :title="$t('Cancel')"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <v-card-text v-if="items < 1" class="mesas__vacio">
          <v-icon size="56" color="grey lighten-1">mdi-table-furniture</v-icon>
          <div class="mesas__vacio-titulo">No hay mesas disponibles</div>
          <p>En este momento no hay mesas disponibles para reservar.</p>
          <v-btn v-if="allowPickup" block large depressed color="primary" @click="setPickup">
            <v-icon left>mdi-bag-personal-outline</v-icon>Para llevar (sin mesa)
          </v-btn>
        </v-card-text>

        <v-card-text class="pa-0" v-else>
          <div class="mesas__zonas">
            <v-chip-group v-model="tab" mandatory active-class="mesas__zona--activa" show-arrows>
              <v-chip v-for="item in items" :key="'vtab_' + item.id" :value="'zone_' + item.id" class="mesas__zona">
                <v-icon left small>mdi-store-outline</v-icon>{{ item.name }}
              </v-chip>
            </v-chip-group>
          </div>

          <v-tabs-items v-model="tab" class="mesas__cuerpo">
            <v-tab-item :value="'zone_' + zone.id" :id="'zone_' + zone.id" v-for="zone in items" :key="'vtab_zone' + zone.id">
              <div class="mesas__rejilla">
                <template v-for="table in zone.tables">
                  <div v-if="table.busy && table.name != order.name_table" :key="'table_' + table.id" :title="table.name" class="mesa mesa--ocupada">
                    <v-icon size="34" color="red lighten-2">mdi-table-furniture</v-icon>
                    <span class="mesa__nombre">{{ table.name }}</span>
                    <span class="mesa__estado">{{ $t("busy") }}</span>
                  </div>
                  <div v-else :key="'table_' + table.id" :title="table.name" class="mesa" :class="{ 'mesa--elegida': isSelectedOrder(table) }" role="button" tabindex="0"
                    @click="setTable(table)" @keyup.enter="setTable(table)">
                    <v-icon size="34" :color="isSelectedOrder(table) ? 'primary' : 'green'">mdi-table-furniture</v-icon>
                    <span class="mesa__nombre">{{ table.name }}</span>
                    <span class="mesa__estado">{{ isSelectedOrder(table) ? $t("selected") : $t("available") }}</span>
                  </div>
                </template>
              </div>
              <template v-if="invalid"></template>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-card-actions v-if="allowPickup && items.length > 0" class="px-4 pb-4 pt-0">
          <v-btn block large outlined color="primary" @click="setPickup">
            <v-icon left>mdi-bag-personal-outline</v-icon>Para llevar (sin mesa)
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<style>
.mesas__encabezado {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}
.mesas__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}
.mesas__zonas {
  padding: 12px 16px 0;
}
.mesas__zona.v-chip {
  font-weight: 500;
  background: #eef1f3 !important;
}
.mesas__zona--activa.v-chip {
  background: var(--v-primary-base) !important;
  color: #fff !important;
}
.mesas__zona--activa.v-chip .v-icon {
  color: #fff !important;
}
.mesas__cuerpo {
  padding: 8px 16px 16px;
  max-height: 60vh;
  overflow-y: auto;
}
.mesas__rejilla {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(112px, 1fr));
  gap: 10px;
  padding-top: 8px;
}
.mesa {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 12px 6px 10px;
  border: 1.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.mesa:hover,
.mesa:focus-visible {
  border-color: #43a047;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  outline: none;
}
.mesa__nombre {
  font-weight: 600;
  line-height: 1.2;
  word-break: break-word;
}
.mesa__estado {
  font-size: 0.75rem;
  color: #43a047;
}
.mesa--elegida {
  border-color: var(--v-primary-base);
  background: rgba(0, 0, 0, 0.03);
}
.mesa--elegida .mesa__estado {
  color: var(--v-primary-base);
  font-weight: 600;
}
.mesa--ocupada {
  cursor: not-allowed;
  background: #fdecea;
  border-color: #f5c6c2;
}
.mesa--ocupada:hover {
  box-shadow: none;
  border-color: #f5c6c2;
}
.mesa--ocupada .mesa__estado {
  color: #d32f2f;
}
.mesas__vacio {
  text-align: center;
  padding: 28px 24px !important;
}
.mesas__vacio-titulo {
  font-size: 1.15rem;
  font-weight: 600;
  margin: 8px 0 4px;
}
</style>
<script>
export default {
  components: {},
  name: "CartTablesRemote",
  data: () => ({
    key: 0,
    items: [],
    table: null,
    tab: null,
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    order: Object,
    // En la app de meseros: ofrece «para llevar» cuando el pedido no va a una mesa.
    allowPickup: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.getTables();
    this.table = this.order.getNameTable();
  },
  methods: {
    selected() {
      const obj = JSON.parse(JSON.stringify(this.item));
      this.clear();
      this.searched = false;
      this.$emit("selected", obj);
      this.key++;
    },
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    clear() {
      this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
    },
    setTable(item) {
      this.$pos.setNameTable(this.order, item.name);
      this.$pos.setIsOnTable(this.order, true);
      this.order.waiter_pickup = false;
      this.$emit("cancel");
    },
    setPickup() {
      this.$pos.setNameTable(this.order, null);
      this.$pos.setIsOnTable(this.order, false);
      this.order.waiter_pickup = true;
      this.$pos.setStorePickup(this.order, true);
      this.$emit("cancel");
    },
    isSelectedOrder(item) {
      if (item.name == this.table) {
        return true;
      }
      return false;
    },
    async getTables() {
      /*const tables = await this.$db.getTables();
      this.items = tables;*/
      const inst = await this.$db.getInstallation();
      this.$http
        .get("api/v1/store-tables/" + inst.subsidiary_id)
        .then((response) => {
          this.items = response.items;
        })
        .catch((error) => {});
    },
  },
};
</script>